<template>
  <div class="wrap">
    <van-nav-bar :fixed="true" left-arrow placeholder @click-left="onClickLeft" :title="$t('address.title')" />
    <van-address-list :class="list.length > 0 ? 'btns_null' : ''" :value="chosenAddressId" :list="list"
      :add-button-text="$t('address.addAddress')" :default-tag-text="$t('address.default')" @add="onAdd" @edit="onEdit"
      @select="onSelect">
      <template>
        <div class="null_img" v-if="!list.length">
          <img :src="verConfig.addressNullPng" alt="">
        </div>
      </template>
    </van-address-list>
  </div>
</template>
<script>
import { NavBar, AddressList, Toast } from "vant";
import { GET_ADDRESS_LIST, ADD_ADDRESS } from "@tt/api";

export default {
  components: {
    [NavBar.name]: NavBar,
    [AddressList.name]: AddressList,
    [Toast.name]: Toast
  },
  data() {
    return {
      init: 0
    }
  },
  computed: {
    list() {
      return this.$store.getters.addressList;
    },
    chosenAddressId() {
      return this.$store.getters.addressList.find(item => item.isDefault)?.id || '';
    }
  },
  created() {
    const { init = 0 } = this.$route.query || {};
    this.init = Number(init);
  },
  methods: {
    onAdd() {
      this.$router.push(`/EditAddress?isAdd=${0}`);
    },
    onEdit(item) {
      this.$router.push(`/EditAddress?isAdd=${1}&id=${item.id}`);
    },
    async onSelect(item, index) {
      const _this = this;
      if (_this.init) {
        sessionStorage.setItem('addressList', JSON.stringify(item));
        return this.$router.go(-1);
      }
      const { indate, isDefault, tel, userid, ...ret } = item;
      if (ret.id == this.chosenAddressId) return;
      try {
        const { msg } = await ADD_ADDRESS({ ...ret, default: 1, phone: tel })
        this.$store.commit("SET_DEFAULT", item.id);
        Toast(msg)
      } catch (error) {
        console.error(error, 'onSelect');
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: #f6f8f9;
  overflow: hidden;

  :deep(.van-address-list__bottom) {
    background-color: #f6f8f9;
    padding-bottom: 20px;
  }
  :deep(.van-address-item__edit){
    display: none;
  }

  .btns_null {
    :deep(.van-address-list__bottom) {
      display: none;
    }
  }

  .null_img {
    width: 100%;
    height: 100%;
    max-width: 750px;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>